import request from '@/utils/request'

const baseUrlSimpleClassZhihuishu = 'https://simple-class.zhihuishu.com/simple-class'
const baseUrlzlazc = 'https://zhs-livecourse-admin.zhihuishu.com'

// 获取登录用户管理的学校：
const getAdminUserSchool = () => {
  return request({
    url: '/admin/school/adminUserSchool/v100',
    method: 'get'
  })
}

// 切换学校：
const switchSchool = (params) => {
  return request({
    url: '/admin/school/switchSchool/v100',
    method: 'get',
    params
  })
}

/**
 * @description: 获取省份列表
 * @param {*} params
 * @return {*}
 */
const getProvinceList = (params) => {
  return request({
    url: '/admin/school/provinceList',
    method: 'get',
    params
  })
}

/**
 * @description: 批量查询省份对应的学校
 * @param {*} params
 * @return {*}
 */
const batchSchoolByProvinceId = (params) => {
  return request({
    url: '/admin/school/batchSchoolByProvinceId',
    method: 'get',
    params
  })
}

/**
 * @description: 获取登录界面相关验证码
 * @param {*} params
 * @return {*}
 */
const sendValidCode = (params) => {
  return request({
    url: '/admin/sendValidCode',
    method: 'get',
    params
  })
}

/**
 * @description: 忘记密码 重置密码
 * @param {*} params
 * @return {*}
 */
const updatePhonePassword = (params) => {
  return request({
    url: '/admin/updatePhonePassword',
    method: 'get',
    params
  })
}

// /**
//  * @description: 获取服务器时间--新的接口
//  * @param {*} params
//  * @return {*}
//  */
//  const getLocalTime = () => {
//   return request({
//     baseURL: baseUrlSimpleClassZhihuishu,
//     url: `/admin/tool/getLocalTime`,
//     method: 'get'
//   })
// }

/**
 * @description: 获取服务器时间--最新
 * @param {*} params
 * @return {*}
 */
const getLocalTime = () => {
  return request({
    url: '/common/getLocalTime',
    method: 'get'
  })
}

/**
 * @description: 获取在线人数
 * @param {object} params
 * @return {*}
 */
const getLiveOnlineNum = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/student/getLiveOnlineNum/v100',
    method: 'get',
    params
  })
}

/**
 * @description: 登出
 * @param {*} params
 * @return {*}
 */
const adminLogout = () => {
  return request({
    url: '/admin/logout',
    method: 'get'
  })
}
/**
 * @description: 查询菜单
 * @param {*} params
 * @return {*}
 */
const getMenuTree = (params) => {
  return request({
    url: '/admin/menu/queryMenus',
    method: 'get',
    params
  })
}

// 获取学校信息
const queryBySchoolCode = (params) => {
  return request({
    baseURL: baseUrlzlazc,
    url: '/dev-api/business/school/queryBySchoolCode',
    method: 'get',
    params
  })
}

export default {
  getLiveOnlineNum,
  updatePhonePassword,
  sendValidCode,
  batchSchoolByProvinceId,
  getProvinceList,
  getAdminUserSchool,
  switchSchool,
  getLocalTime,
  adminLogout,
  getMenuTree,
  queryBySchoolCode
}
